/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsBCSQuestionsAnswersHistoryResponse {
    getFixupPrototypeFunction() { return AppSecopsBCSQuestionsAnswersHistoryResponse.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsBCSQuestionsAnswersHistoryResponse>): AppSecopsBCSQuestionsAnswersHistoryResponse {
        let obj = Object.assign(new AppSecopsBCSQuestionsAnswersHistoryResponse(), model);
        AppSecopsBCSQuestionsAnswersHistoryResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsBCSQuestionsAnswersHistoryResponse>): AppSecopsBCSQuestionsAnswersHistoryResponse {
        if (!model) return null;
        return AppSecopsBCSQuestionsAnswersHistoryResponse.newInstance(<AppSecopsBCSQuestionsAnswersHistoryResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsBCSQuestionsAnswersHistoryResponse) {
        if (!obj) return;

        models.AppSecopsBCSQuestionsAnswersHistoryResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsBCSQuestionsAnswersHistoryResponse): boolean {
        Object.setPrototypeOf(obj, AppSecopsBCSQuestionsAnswersHistoryResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.next_list_context) {
            models.ListContext.fixupPrototype(this.next_list_context);
        }
        if (this.items) {
            for (let val of this.items) {
                models.AppSecopsBCSQuestionsAnswers.fixupPrototype(val);
            }
        }
    }

    /**
     * List of resources matching the trend criteria.
     */
    items: Array<models.AppSecopsBCSQuestionsAnswers>;

    /**
     * List context
     */
    next_list_context: models.ListContext;

}
